import { render, staticRenderFns } from "./BlankoHeaderComp.vue?vue&type=template&id=28e6310c&scoped=true&"
import script from "./BlankoHeaderComp.vue?vue&type=script&lang=ts&"
export * from "./BlankoHeaderComp.vue?vue&type=script&lang=ts&"
import style0 from "./BlankoHeaderComp.vue?vue&type=style&index=0&id=28e6310c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e6310c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBtn,VIcon,VMenu,VTooltip})
